var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.123 0H3.274A2.489 2.489 0 00.789 2.492v14.954a2.489 2.489 0 002.485 2.492h24.85a2.489 2.489 0 002.484-2.492V2.492A2.489 2.489 0 0028.123 0z",
    fill: "#252525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.97 16.2c3.431 0 6.212-2.79 6.212-6.231s-2.78-6.23-6.212-6.23c-3.43 0-6.212 2.789-6.212 6.23 0 3.441 2.781 6.23 6.212 6.23z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.427 16.2c3.431 0 6.212-2.79 6.212-6.231s-2.78-6.23-6.212-6.23c-3.43 0-6.212 2.789-6.212 6.23 0 3.441 2.781 6.23 6.212 6.23z",
    fill: "#F79E1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7 4.984a6.227 6.227 0 012.485 4.985 6.228 6.228 0 01-2.485 4.986 6.228 6.228 0 01-2.485-4.986c0-2.038.976-3.848 2.485-4.985z",
    fill: "#FF5F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/MasterCard.73a291c55ac7a6f0b48fd27dc60e3d64.svg";
export { ForwardRef as ReactComponent };